import React, { useEffect } from "react";
import { useContextEmpleado } from "../../contexto/empleado/EmpleadoContext";

const MetodosPagos = ({
    efectivo,
    setEfectivo,
    montosPos,
    setMontosPos,
    referenciasPos,
    setReferenciasPos,
    erroresReferenciaPos,
    setErroresReferenciaPos,
    montosTransferencia,
    setMontosTransferencia,
    referenciasTransferencia,
    setReferenciasTransferencia,
    erroresReferenciaTransferencia,
    setErroresReferenciaTransferencia,
    pos,
    setPos,
    transferencias,
    setTransferencias,
    formatoMoneda,
    totalConRecargo,
    totalRecibido,
}) => {
    const { listaBancos } = useContextEmpleado();

    const obtenerCuentasPorTipo = (tipo) => {
        return listaBancos
            .filter(banco => banco.activo)
            .flatMap(banco =>
                banco.cuenta
                    .filter(c => c.tipoCuenta === tipo && c.activo)
                    .map(c => {
                        const idParaPago =
                            tipo === 'Pos' && c.pos.length > 0 && c.pos[0].activo
                                ? c.pos[0].id
                                : c.id; 
                        const nombre = tipo === 'Pos' ? c.pos[0]?.nombre || c.nombre : c.nombre;
                        return {
                            id: idParaPago,
                            nombre: nombre,
                            bancoNombre: banco.nombre,
                            digitosMinimos: tipo === 'Pos' ? 6 : 8,
                        };
                    })
            );
    };
    const listaPosCuentas = obtenerCuentasPorTipo('Pos');
    const listaTransferenciaCuentas = obtenerCuentasPorTipo('Transferencia');

    useEffect(() => {
        const totalPos = Object.values(montosPos).reduce((acc, monto) => acc + parseFloat(monto || 0), 0);
        const totalTransferencias = Object.values(montosTransferencia).reduce((acc, monto) => acc + parseFloat(monto || 0), 0);

        setPos(totalPos);
        setTransferencias(totalTransferencias);
    }, [montosPos, montosTransferencia, setPos, setTransferencias]);


    const renderMetodoPago = (cuenta, montoState, setMontoState, referenciaState, setReferenciaState, errorState, setErrorState, tipo) => {
        const id = cuenta.id;
        const digitos = cuenta.digitosMinimos;

        const handleMontoChange = (e) => {
            const valor = e.target.value;
            setMontoState(prev => ({ ...prev, [id]: valor }));
        };

        const handleReferenciaChange = (e) => {
            const valor = e.target.value;
            setReferenciaState(prev => ({ ...prev, [id]: valor }));

            const regex = new RegExp(`^\\d{${digitos},15}$`);
            setErrorState(prev => ({ ...prev, [id]: valor !== '' && !regex.test(valor) }));
        };

        return (
            <tr key={id}>
                <td>
                    {tipo === 'pos' ? cuenta.nombre : cuenta.bancoNombre}
                </td>
                <td>
                    <label htmlFor={`monto-${id}`}>Monto</label>
                    <input type="number"
                        id={`monto-${id}`} 
                        key={`monto-${id}`}
                        className="form-control"
                        placeholder="L 0.00"
                        value={montoState[id] || ''}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleMontoChange}
                    />
                </td>
                <td>
                    <label htmlFor={`referencia-${id}`}>Referencia</label>
                    <input
                        type="text"
                        id={`referencia-${id}`}
                        key={`referencia-${id}`}
                        className={`form-control ${errorState[id] ? 'is-invalid' : ''}`}
                        placeholder={`Mínimo ${digitos} dígitos`}
                        value={referenciaState[id] || ''}
                        onChange={handleReferenciaChange}
                    />
                    {errorState[id] && (
                        <div className="invalid-feedback">
                            La referencia debe tener al menos {digitos} dígitos numéricos.
                        </div>
                    )}
                </td>
            </tr>
        );
    };

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="table-responsive">
                    <table className="table table-hover">
                        <tbody>
                            <tr>
                                <td>Efectivo:</td>
                                <td colSpan={2}>
                                    <input type="number" className="form-control" placeholder="L 0.00"
                                        value={efectivo}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => setEfectivo(e.target.value)}
                                    />
                                </td>
                            </tr>

                            {listaPosCuentas.length > 0 && (
                                <tr data-widget="expandable-table" aria-expanded="false">
                                    <th>POS:</th>
                                    <th>{formatoMoneda(pos)}</th>
                                </tr>
                            )}
                            <tr className="expandable-body d-none">
                                <td colSpan={3}>
                                    <div>
                                        <table className="table table-hover">
                                            <tbody>
                                                {listaPosCuentas.map(cuenta =>
                                                    renderMetodoPago(
                                                        cuenta,
                                                        montosPos,
                                                        setMontosPos,
                                                        referenciasPos,
                                                        setReferenciasPos,
                                                        erroresReferenciaPos,
                                                        setErroresReferenciaPos,
                                                        'pos'
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>

                            {listaTransferenciaCuentas.length > 0 && (
                                <tr data-widget="expandable-table" aria-expanded="false">
                                    <th>Transferencias:</th>
                                    <th>{formatoMoneda(transferencias)}</th>
                                </tr>
                            )}
                            <tr className="expandable-body d-none">
                                <td colSpan={3}>
                                    <div>
                                        <table className="table table-hover">
                                            <tbody>
                                                {listaTransferenciaCuentas.map(cuenta =>
                                                    renderMetodoPago(
                                                        cuenta,
                                                        montosTransferencia,
                                                        setMontosTransferencia,
                                                        referenciasTransferencia,
                                                        setReferenciasTransferencia,
                                                        erroresReferenciaTransferencia,
                                                        setErroresReferenciaTransferencia,
                                                        'transferencia'
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <th>Recibido:</th>
                                <th colSpan={2}>{formatoMoneda(totalRecibido)}</th>
                            </tr>
                            <tr>
                                <th>Total a Pagar:</th>
                                <th colSpan={2}>{formatoMoneda(totalConRecargo)}</th>
                            </tr>
                            <tr>
                                <th>Cambio:</th>
                                <th colSpan={2}>{formatoMoneda(totalRecibido - parseFloat(totalConRecargo))}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default MetodosPagos;